import * as React from 'react';

import * as Yup from 'yup';
import {
	Form, Formik, FormikHelpers as FormikActions, FormikProps,
} from 'formik';
import Rate from 'antd/lib/rate';
import Modal from 'antd/lib/modal';
import Message from 'antd/lib/message';

import { simpleStringValidator } from '@common/react/utils/validationHelpers';
import FormikField from '@common/react/components/Forms/FormikField/FormikField';
import Button from '@common/react/components/Forms/Button';

import { Review } from '@app/objects/Review';
import { request } from '@app/components/Api';
import { DoctorReview } from '@app/objects/DoctorReview';

type FormValues = Partial<Review>;

const validationSchema = Yup.object().shape({
	textEn: simpleStringValidator,
});

interface AddReviewModalProps {
	doctorId: number;
	appointmentId?: number | null;
}

const AddReview: React.FC<AddReviewModalProps> = ({
	doctorId,
	appointmentId = null,
}) => {
	const [saveLoading, setSaveLoading] = React.useState<boolean>(false);
	const [visible, setVisible] = React.useState<boolean>(false);

	React.useEffect(() => {
		if (appointmentId && appointmentId > 0) {
			setVisible(true);
		}
	}, [appointmentId]);

	const onSubmit = (formValues: FormValues, formikActions: FormikActions<FormValues>) => {
		setSaveLoading(true);

		request<Review>('review', {
			...formValues,
			appointmentId,
		})
			.then((res) => {
				formikActions.resetForm();
				setVisible(false);
				Message.success('Your review was successfully sent!');
			})
			.catch((err) => {
				Message.error(err);
			})
			.finally(() => setSaveLoading(false));
	};

	const initialValues: Partial<Review> = {
		id: -1,
		textEn: '',
		textEs: '',
		rate: 0,
		doctors: doctorId > 0 ? [{
			id: -1,
			doctorId,
		} as DoctorReview]
			: [],
	};

	return (<>
		<button
			type="button"
			className="btn btn-primary"
			title="Write a review for the doctor"
			onClick={() => {
				setVisible(true);
			}}
		>
			Leave review
		</button>
		<Modal
			title="Add review"
			open={visible}
			onCancel={() => {
				setVisible(false);
			}}
			destroyOnClose
			width={800}
			footer={null}
		>
			<Formik
				initialValues={initialValues}
				onSubmit={(formik, actions) => onSubmit(formik, actions)}
				enableReinitialize
				validationSchema={validationSchema}
				render={(formikBag: FormikProps<FormValues>) => {
					return <Form id="review-form">
						<div className="row">
							<FormikField
								fieldName="rate"
								title="Rating"
								render={({ field, form }) => (
									<Rate
										value={field.value}
										onChange={(value) => form.setFieldValue(field.name, +value)}
									/>
								)}
							/>
						</div>
						<div className="row">
							<FormikField
								fieldName="textEn"
								title="Text*"
								containerClassName="form-group col-sm-12"
								render={({ field }) => {
									return <textarea
										className="form-control"
										id={field.name}
										{...field}
										value={field.value === null ? '' : field.value}
										style={{ resize: 'none', height: '250px' }}
									/>;
								}}
							/>
						</div>
						<div className="clearfix form-group">
							<div className="text-center">
								<Button
									type="button"
									className="btn btn-primary"
									onClick={() => { formikBag.submitForm(); }}
									isLoading={saveLoading}
								>
									Save
								</Button>
							</div>
						</div>
					</Form>;
				}}
			/>
		</Modal>
	</>);
};

export default AddReview;
